import Vue from 'vue'
import VueMeta from 'vue-meta'
import store from '@/store'

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
})

function metaToOg(meta) {
  const item = {
    type: 'website',
    title: meta.title,
    description: meta.description,
    url: meta.url,
    image: meta.image,
    site_name: meta.author,
  }
  const result = []
  for (const key in item) {
    result.push({
      property: `og:${key}`,
      content: item[key],
    })
  }
  return result
}

function metaToTwitter(meta) {
  const item = {
    card: 'summary',
    title: meta.title,
    description: meta.description,
    image: meta.image,
    domain: location.origin,
  }
  const result = []
  for (const key in item) {
    result.push({
      name: `twitter:${key}`,
      content: item[key],
    })
  }

  return result
}

function metaToDefaultMeta(meta) {
  const item = {
    description: meta.description,
    keywords: meta.keywords,
    author: meta.author,
  }
  const result = []
  for (const key in item) {
    result.push({
      name: key,
      content: item[key],
    })
  }

  return result
}

function othersMeta(meta) {
  const item = {
    'apple-mobile-web-app-title': meta.author,
    'apple-mobile-web-app-capable': 'yes',
    'mobile-web-app-capable': 'yes',
    'theme-color': '#0CAEFF',
    'msapplication-TileColor': '#00A9FF',
    'msapplication-TileImage': '',
  }

  const result = []
  for (const key in item) {
    result.push({
      name: key,
      content: item[key],
    })
  }

  return result
}

function othersLink(meta) {
  return [
    {
      rel: 'canonical',
      href: location.origin,
    },
    // {
    //   rel: 'apple-touch-icon-precomposed',
    //   href: null
    // }, {
    //   rel: 'apple-touch-icon',
    //   href: null
    // }, {
    //   rel: 'icon',
    //   type: 'image/png',
    //   href: null,
    //   sizes: '500x500'
    // }
  ]
}

/**
 *
 * @param {*} vm 현재페이지 created의 this
 * @param {*} obj defaultMeta에 있는 항목과 비슷한 형식의 값
 */
global._meta = async (obj) => {
  let defaultTitle = '번개입금'
  if (store.state.myfinbiz?.organization) {
    defaultTitle = store.state.myfinbiz.organization.name
  }

  const meta = Object.assign(
    {
      author: 'funda',
      title: defaultTitle,
      titlesDefault: defaultTitle,
      titles: [],
      description: defaultTitle,
      keywords: defaultTitle,
      type: null,
      url: null,
      image: '',
      meta: [],
      link: [],
    },
    { url: location.href },
    obj,
  )

  if (meta.titles) {
    let title = ''
    meta.titles.unshift(meta.titlesDefault)
    meta.titles.reverse()

    for (var i = 0; i < meta.titles.length; i++) {
      title += meta.titles[i]
      if (i !== meta.titles.length - 1) {
        title += ' | '
      }
    }
    delete meta.titles
    meta.title = title
  }

  if (meta.image.startsWith('http') === false) {
    meta.image = `${location.protocol}//${location.host}${meta.image}`
  }
  // og
  meta.meta = meta.meta
    .concat(metaToOg(meta)) // og
    .concat(metaToTwitter(meta)) // twitter
    .concat(metaToDefaultMeta(meta)) // default
    .concat(othersMeta(meta)) // others

  meta.link = meta.link.concat(othersLink(meta))

  store.dispatch('meta/set', meta)

  return meta
}
